//@ utilities
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
//@ actions
const signaturePatternActions = require('actions/signaturePattern');
//@ constants
const actionTypes = require('constants/actionTypes');

const setImport = value => ({
    type: actionTypes.CARD_PAY_LATER_IMPORT_SET,
    payload: { import: value }
});

const setVisibleStep = step => ({
    type: actionTypes.CARD_PAY_LATER_SET_VISIBLE_STEP,
    payload: { step }
});

const validateStep = step => ({
    type: actionTypes.CARD_PAY_LATER_VALIDATE_STEP,
    payload: { step }
});

const setWillCancel = willCancel => ({
    type: actionTypes.CARD_PAY_LATER_WILL_CANCEL,
    payload: { willCancel }
});

const clearRequest = () => ({ type: actionTypes.CARD_PAY_LATER_CLEAR });

const successChange = payload => ({
    type: actionTypes.CARD_PAY_LATER_SUCCESS,
    payload
});

const failureChange = error => ({
    type: actionTypes.CARD_PAY_LATER_FAILURE,
    payload: { error }
});

const requestChange = () => ({ type: actionTypes.CARD_PAY_LATER_REQUEST });

const getPayLaterInfoRequest = () => ({ type: actionTypes.CARD_GET_PAY_LATER_INFORMATION_REQUEST });

const getPayLaterInfoFailure = error => ({
    type: actionTypes.CARD_GET_PAY_LATER_INFORMATION_FAILURE,
    payload: { error }
});

const getPayLaterInfoSuccess = (payload, limitsData) => {
    Object.assign(payload, {
        limitsData
    });

    return {
        type: actionTypes.CARD_GET_PAY_LATER_INFORMATION_SUCCESS,
        payload
    };
};

const setImportMaxMin = (min, max) => ({
    type: actionTypes.CARD_PAY_LATER_IMPORT_SET_MAX_MIN,
    payload: {
        min,
        max
    }
});

const postPayLater = cardId => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const immCardPayLater = getState().cardPayLater.get('steps').get('0');
        const immCard = getState().cards.get('byId').get(cardId);
        const requestData = {
            query: {
                dataToken,
                codMoneda: immCard.getIn(['availableBalance', 'currency']),
                listadoRefin: immCardPayLater.getIn(['limitsData', 'listadoRefin']).toJS(),
                importePagar: immCardPayLater.get('import'),
                tarjeta: immCard.get('number'),
                contrato: {
                    numerodecontrato: immCard.getIn(['contract', 'number']),
                    producto: immCard.getIn(['contract', 'product'])
                }
            }
        };

        dispatch(requestChange());
        APIPost({ dispatch, endpoint: 'cardPayLater', params: requestData })
            .then(response => dispatch(successChange(response)))
            .catch(response => {
                if (!!response.error) {
                    dispatch(failureChange(response.error.description));
                } else {
                    throw response;
                }
            });
    };

    new Promise(function() {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
};

const requestPayLaterInfo = cardId => (dispatch, getState) => {
    const immCard = getState().cards.get('byId').get(cardId);
    const params = {
        query: {
            pan: immCard.get('number').split(' ').join(''),
            numeroContrato: immCard.getIn(['contract', 'number']),
            producto: immCard.getIn(['contract', 'product'])
        }
    };
    const requestData = {
        query: {
            producto: immCard.getIn(['contract', 'product'], ''),
            numeroContrato: immCard.getIn(['contract', 'number'], '')
        }
    };

    dispatch(getPayLaterInfoRequest());
    //This service is called to get the payment method
    return APIPost({
        dispatch,
        endpoint: 'cardPayLaterLimitDates',
        params
    })
    .then(limitsData => {
        return APIGet({dispatch, endpoint:'cardChangePaymentMethod', params: requestData})
            .then(response => dispatch(getPayLaterInfoSuccess(response, limitsData)))
    })
    .catch(response => {
        if (!!response.error) {
            dispatch(getPayLaterInfoFailure(response.error.description))
        } else {
            throw response;
        }
    });
};

module.exports = {
    setImport,
    setVisibleStep,
    validateStep,
    setWillCancel,
    postPayLater,
    clearRequest,
    requestPayLaterInfo,
    setImportMaxMin
};
